import { useRef } from 'react';

function getStableImageKey(src: string): string {
  try {
    const url = new URL(src, globalThis.location?.origin);

    return `${url.origin}${url.pathname}`;
  } catch {
    return src;
  }
}

export function useStableImageSource(src: string | null | undefined) {
  const previousSourceRef = useRef<{
    key: string;
    src: string;
  } | null>(null);

  if (!src) {
    previousSourceRef.current = null;
    return null;
  }

  const key = getStableImageKey(src);
  const previousSource = previousSourceRef.current;

  if (previousSource?.key === key) {
    return previousSource.src;
  }

  previousSourceRef.current = {
    key,
    src,
  };

  return src;
}
